// extracted by mini-css-extract-plugin
export var badge = "cfooter-module--badge--e9fb8";
export var bottomFooter = "cfooter-module--bottomFooter--b2010";
export var links = "cfooter-module--links--f4d02";
export var pipe = "cfooter-module--pipe--ad194";
export var texts = "cfooter-module--texts--38cb2";
export var textsWrapper = "cfooter-module--textsWrapper--eba77";